import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/shared/store/auth.store';
import { AdminLayout } from '@/features/admin/components/admin-layout';

export const Route = createFileRoute('/admin')({
  beforeLoad: () => {
    if (!useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
  component: AdminLayout,
});
